import React from 'react';
import { BaseComponent } from 'components/BaseComponent';
import YoutubeEmbed from 'components/YoutubeEmbed/index';
import { getCdnImage } from 'functions';

const styles = require('./bannerCenter.css');

interface IProps {
  media: string;
  isVideo: boolean;
  title: string;
}

export class BannerCenter extends BaseComponent<any, IProps> {
  getMedia() {
    if (this.props.isVideo && this.props.media) {
      return <YoutubeEmbed url={this.props.media} />;
    }

    if (!this.props.isVideo && this.props.media) {
      const bannerCenter = getCdnImage(this.props.media);
      return <img src={bannerCenter.includes('data:') ? this.props.media : bannerCenter} alt={this.props.title} />;
    }

    return null;
  }

  render() {
    return (
      <div className={`chk-media-content ${styles.component}`}>
        {this.getMedia()}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Cart/Templates/Hotsite/BannerCenter/index.tsx